var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC084"
    },
    d: "M325.715,306.275c-10.798-2.17-18.567-14.696-18.567-25.711v-49.082H256l0,0h-51.148v49.082 c0,11.014-7.769,23.54-18.567,25.711l-12.463,3.518v82.689H256l0,0h82.177v-82.689L325.715,306.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B076"
    },
    d: "M271.198,231.482v73.576c0,10.383,7.242,22.141,17.08,25.269c0.598,0.19,0.868,0.317,1.487,0.441 l48.413,15.112v-36.088l-12.463-3.519c-10.798-2.17-18.567-14.696-18.567-25.711V231.48h-35.95V231.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C861"
    },
    d: "M488.153,426.338c0-43.522-28.665-81.844-70.414-94.136l-94.166-29.361 c-2.923-0.911-6.111-0.171-8.333,1.935L256,360.916l-59.239-56.139c-2.223-2.106-5.41-2.846-8.333-1.935l-94.166,29.361 c-41.749,12.292-70.415,50.615-70.415,94.136v66.243c0,10.725,8.694,19.419,19.419,19.419h425.47 c10.725,0,19.419-8.694,19.419-19.419v-66.244H488.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3A656"
    },
    d: "M481.698,391.314c-0.931-2.434-1.956-4.826-3.073-7.168c-3.35-7.028-7.519-13.622-12.405-19.645 c-5.701-7.026-12.376-13.273-19.865-18.525c-6.419-4.501-13.434-8.27-20.944-11.17c-2.503-0.967-5.062-1.837-7.671-2.605 l-94.166-29.36c-1.096-0.342-2.23-0.451-3.335-0.344c-1.843,0.179-3.609,0.962-4.998,2.279l-26.962,25.551l83.799,26.128 c41.749,12.292,70.414,36.635,70.414,80.156V512h26.244c10.725,0,19.419-8.694,19.419-19.419v-66.243 C488.154,414.098,485.886,402.268,481.698,391.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC084"
    },
    d: "M358.627,124.338h-6.55v-7.692V98.259c0-25.962-10.658-51.118-30.331-68.058 C306.321,16.92,284.64,5.328,256,5.008c-28.64,0.32-50.321,11.912-65.745,25.193c-19.673,16.94-30.331,42.096-30.331,68.058v18.387 v7.692h-6.55c-9.603,0-17.389,7.785-17.389,17.389v19.269c0,9.603,7.785,17.389,17.389,17.389h6.577 c0.542,25.236,11.147,49.527,30.305,66.023c15.424,13.281,37.105,24.873,65.745,25.193c28.64-0.32,50.321-11.912,65.745-25.193 c19.159-16.497,29.764-40.787,30.305-66.023h6.577c9.603,0,17.389-7.785,17.389-17.389v-19.269 C376.016,132.123,368.231,124.338,358.627,124.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B076"
    },
    d: "M358.627,124.338h-6.55v-7.692V98.259c0-25.962-10.658-51.118-30.332-68.058 C306.321,16.92,284.64,5.328,256,5.008c-6.265,0.07-12.197,0.679-17.803,1.728c20.023,3.744,35.892,13.089,47.942,23.465 c19.673,16.94,30.332,42.096,30.332,68.058v18.387l-0.026,61.739c-0.542,25.236-11.147,49.527-30.305,66.023 c-12.05,10.376-27.919,19.721-47.942,23.465c5.606,1.048,11.538,1.658,17.803,1.727c28.64-0.319,50.321-11.912,65.745-25.193 c19.159-16.497,29.764-40.787,30.305-66.023h6.577c9.603,0,17.389-7.785,17.389-17.389v-19.269 C376.016,132.123,368.231,124.338,358.627,124.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F6D"
    },
    d: "M330.388,15.616L270.153,1.802c-10.672-2.447-21.764-2.402-32.416,0.134l-56.505,13.45 c-21.311,5.073-36.351,24.113-36.351,46.02v63.82h222.238V61.725C367.119,39.672,351.882,20.545,330.388,15.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F93A5A"
    },
    d: "M330.388,15.616L270.153,1.802c-10.672-2.447-21.764-2.402-32.416,0.134l-1.448,0.345l58.148,13.335 c21.494,4.929,36.732,24.056,36.732,46.109v63.502h35.95V61.725C367.119,39.672,351.882,20.545,330.388,15.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C5871"
    },
    d: "M340.67,152.052c-56.067-17.223-113.275-17.222-169.341,0c-9.721,2.986-19.973-2.748-22.614-12.568 c-1.278-4.752-2.556-9.504-3.835-14.256c73.267-27.458,148.967-27.461,222.238,0c-1.278,4.752-2.556,9.504-3.835,14.256 C360.643,149.303,350.391,155.038,340.67,152.052z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED864A"
    },
    d: "M422.163,422.403c-4.275,0-7.74,3.465-7.74,7.741V512h15.481v-81.856 C429.903,425.868,426.438,422.403,422.163,422.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED864A"
    },
    d: "M89.837,422.403c-4.275,0-7.74,3.465-7.74,7.741V512h15.481v-81.856 C97.578,425.868,94.113,422.403,89.837,422.403z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C5871"
    },
    d: "M255.389,421.047L255.389,421.047c-3.066,0-5.843-1.809-7.081-4.614l-23.135-52.39 c-1.726-3.911,0.044-8.48,3.955-10.208c3.912-1.724,8.48,0.043,10.208,3.955l16.053,36.355l16.055-36.355 c1.727-3.912,6.299-5.681,10.207-3.954c3.912,1.727,5.681,6.296,3.954,10.207l-23.136,52.39 C261.232,419.237,258.454,421.047,255.389,421.047z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED864A"
    },
    d: "M196.761,304.776L256,360.916l-36.534,12.446c-8.951,3.049-18.858,0.398-25.09-6.714l-45.188-51.571 l39.24-12.235C191.351,301.93,194.538,302.67,196.761,304.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED864A"
    },
    d: "M315.239,304.776L256,360.916l36.534,12.446c8.951,3.049,18.858,0.398,25.09-6.714l45.188-51.571 l-39.24-12.235C320.649,301.93,317.462,302.67,315.239,304.776z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4F6D"
    },
    d: "M280.603,435.876c0-13.429-10.759-24.345-24.127-24.599c-13.791-0.262-25.079,11.359-25.079,25.153 v47.267c0,1.951,1.582,3.533,3.533,3.533h19.393c1.951,0,3.533-1.582,3.533-3.533v-23.295 C270.576,459.452,280.603,448.839,280.603,435.876z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.ea1c4d5a7e60a66833eb372d59436b96.svg";
export { ForwardRef as ReactComponent };